module.exports = __webpack_public_path__ + "static/img/prize.2645f3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prize.jpg
// module id = 100
// module chunks = 1